import { render, staticRenderFns } from "./posterShare.vue?vue&type=template&id=9a7e8f00&scoped=true&"
import script from "./posterShare.vue?vue&type=script&lang=js&"
export * from "./posterShare.vue?vue&type=script&lang=js&"
import style0 from "./posterShare.vue?vue&type=style&index=0&id=9a7e8f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a7e8f00",
  null
  
)

export default component.exports